export const SNIPPET_LIST_REQUEST = "SNIPPET_LIST_REQUEST"
export const SNIPPET_LIST_SUCCESS = "SNIPPET_LIST_SUCCESS"
export const SNIPPET_LIST_FAIL = "SNIPPET_LIST_FAIL"
export const QUERY_PAGE = "page"
export const QUERY_NAME = "name"
export const QUERY_LIMIT = "limit"
export const QUERY_SEARCH = "search"
export const QUERY_DIRECTION = "DIRECTION"
